import { Channel } from 'frontendcommon-3'
// import Auth from '@/auth/Auth'
const UNAUTHORIZED_STATUS_CODE = 401
const FORBIDDEN_STATUS_CODE = 403

// const auth = new Auth()
const configRequest = function () {
  return async (config) => {
    return config
  }
}
/* MANAGE BACKEND RESPONSE ERROR */
const manageResponse = function () {
  return async (error) => {
    if (error.response) {
      const { status } = error.response
      if (status === UNAUTHORIZED_STATUS_CODE) {
        Channel.emitTokenUnauthorized()
      } else if (status === FORBIDDEN_STATUS_CODE) {
        Channel.emitForbiddenRequest()
      }
    }
    return Promise.reject(error)
  }
}

export default {
  install: function (Vue, options) {
    options.axios.defaults.baseURL = options.gatewayBaseUrl
    options.axios.defaults.withCredentials = true
    options.axios.interceptors.request.use(
      configRequest(options),
      (error) => {
        return Promise.reject(error)
      }
    )
    options.axios.interceptors.response.use(
      response => response,
      manageResponse(options)
    )
  }
}
